import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  TableContainer,
} from '@mui/material';

type InfoTableRow = {
  key: string;
  cells: React.ReactNode[];
};

type InfoTableProps = {
  dataTestId: string;
  title: string;
  rows: InfoTableRow[];
  columns: string[];
};

export function PolicyInformationInfoTable({
  dataTestId,
  title,
  rows,
  columns,
}: Readonly<InfoTableProps>) {
  return (
    <Box sx={{ padding: '1.5rem' }}>
      <Typography variant="subtitle1" sx={{ color: 'text.primary' }} data-testid="policy-table-title">
        {title}
      </Typography>
      <TableContainer sx={{ mt: 3, borderBottom: '1px dashed var(--palette-divider)' }}>
        <Table data-testid={dataTestId}>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={`${dataTestId}-header-${col}`}
                  sx={{ verticalAlign: 'middle', width: `${100 / columns.length}%` }}
                >
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.key}>
                {row.cells.map((cell, cellIndex) => (
                  <TableCell
                    key={`${row.key}-${columns[cellIndex]}`}
                    data-testid={`${dataTestId}-row-${row.key}-col-${columns[cellIndex]}`}
                    sx={{ verticalAlign: 'middle' }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
